/* Tema LOF — JS base.
   Substitui o cartStore.ts (Storefront API) pela AJAX Cart API nativa.
   Inclui: troca de variante, quantidade, cart drawer. */
(function () {
  'use strict';

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var fmt = function (cents) { return money.format((cents || 0) / 100); };

  /* ───────── Cart count ───────── */
  function setCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
  }

  async function getCart() {
    var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  /* ───────── Cart drawer ───────── */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      drawer.querySelector('[data-cart-overlay]').classList.add('opacity-100');
      drawer.querySelector('[data-cart-panel]').classList.remove('translate-x-full');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.querySelector('[data-cart-overlay]').classList.remove('opacity-100');
    drawer.querySelector('[data-cart-panel]').classList.add('translate-x-full');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.classList.add('hidden');
      drawer.setAttribute('aria-hidden', 'true');
    }, 300);
  }

  function renderCart(cart) {
    setCount(cart);
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footerEl = drawer.querySelector('[data-cart-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');

    if (!cart.items.length) {
      itemsEl.innerHTML = '';
      itemsEl.classList.add('hidden');
      emptyEl.classList.remove('hidden');
      footerEl.classList.add('hidden');
      return;
    }
    itemsEl.classList.remove('hidden');
    emptyEl.classList.add('hidden');
    footerEl.classList.remove('hidden');
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<p class="text-xs text-muted-foreground">' + item.variant_title + '</p>' : '';
      return '' +
        '<div class="flex gap-3" data-line-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="w-20 h-20 rounded-md overflow-hidden bg-secondary/30 shrink-0">' +
            (img ? '<img src="' + img + '" alt="" class="w-full h-full object-cover">' : '') +
          '</a>' +
          '<div class="flex-1 min-w-0">' +
            '<p class="font-medium text-sm leading-snug">' + item.product_title + '</p>' +
            variant +
            '<div class="flex items-center justify-between mt-2">' +
              '<div class="flex items-center border border-input rounded-md h-8">' +
                '<button type="button" data-line-dec class="px-2 h-full text-sm hover:bg-secondary">−</button>' +
                '<span class="w-8 text-center text-sm">' + item.quantity + '</span>' +
                '<button type="button" data-line-inc class="px-2 h-full text-sm hover:bg-secondary">+</button>' +
              '</div>' +
              '<span class="text-sm font-semibold">' + fmt(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  async function changeLine(key, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    return res.json();
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
        closeDrawer();
        return;
      }
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('span.w-8');
      var qty = parseInt(qtyEl.textContent, 10);
      if (e.target.closest('[data-line-inc]')) changeLine(key, qty + 1).then(renderCart);
      if (e.target.closest('[data-line-dec]')) changeLine(key, qty - 1).then(renderCart);
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      getCart().then(function (c) { renderCart(c); openDrawer(); });
    }
  });

  /* ───────── Menu mobile ───────── */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('hidden');
    mobileMenu.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      mobileMenu.querySelector('[data-mobile-overlay]').classList.add('opacity-100');
      mobileMenu.querySelector('[data-mobile-panel]').classList.remove('-translate-x-full');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.querySelector('[data-mobile-overlay]').classList.remove('opacity-100');
    mobileMenu.querySelector('[data-mobile-panel]').classList.add('-translate-x-full');
    document.body.style.overflow = '';
    setTimeout(function () {
      mobileMenu.classList.add('hidden');
      mobileMenu.setAttribute('aria-hidden', 'true');
    }, 300);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]') || e.target.closest('[data-mobile-overlay]')) { closeMenu(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* ───────── Add to cart (forms) ───────── */
  async function addVariant(variantId, quantity) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    });
    if (!res.ok) throw new Error('add_failed');
    var cart = await getCart();
    renderCart(cart);
    openDrawer();
  }

  /* Cards de produto (coleção/home) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    addVariant(id, 1).catch(function () { form.submit(); }).finally(function () { if (btn) btn.disabled = false; });
  });

  /* ───────── Página de produto: variantes + quantidade ───────── */
  function initProduct() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var form = section.querySelector('[data-product-form]');
    var variantsEl = section.querySelector('[data-product-variants]');
    if (!form || !variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent || '[]');
    var selectors = Array.from(section.querySelectorAll('[data-option-selector]'));
    var priceContainer = section.querySelector('[data-price-container]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var mainImg = document.getElementById('ProductMainImage');
    var current = variants[0];

    /* A foto do palco nasce com srcset, para o celular não baixar a versão de
       desktop de uma imagem que cabe em 327px. Na troca de tom ou de miniatura
       o srcset venceria o src novo e a foto simplesmente não mudaria — por
       isso ele sai antes de qualquer troca. O peso da primeira tela, que é o
       que conta para o LCP, continua responsivo. */
    function trocarFoto(src, alt) {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      mainImg.alt = alt || '';
    }

    function currentOptions() {
      if (!selectors.length) return null;
      return selectors.sort(function (a, b) {
        return a.getAttribute('data-option-index') - b.getAttribute('data-option-index');
      }).map(function (s) { return s.value; });
    }

    function findVariant() {
      var opts = currentOptions();
      if (!opts) return variants[0];
      return variants.find(function (v) {
        return JSON.stringify(v.options) === JSON.stringify(opts);
      });
    }

    function renderPrice(v) {
      if (!priceContainer) return;
      var html = '<div class="flex items-baseline gap-2">';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<span class="text-muted-foreground line-through text-sm">' + fmt(v.compare_at_price) + '</span>';
        html += '<span class="text-foreground font-semibold">' + fmt(v.price) + '</span>';
        html += '<span class="text-xs font-medium text-destructive">-' + pct + '%</span>';
      } else {
        html += '<span class="text-foreground font-semibold">' + fmt(v.price) + '</span>';
      }
      html += '</div>';
      priceContainer.innerHTML = html;
    }

    /* A troca de foto só vale a partir de uma ação da pessoa. Na carga, a
       galeria fica na foto do produto: numa coloração de nove tons, todas
       as variantes têm a mecha como imagem, e trocar no load abria a PDP
       na mecha em vez da bisnaga. */
    var primeiraPassada = true;

    function update() {
      var v = findVariant();
      if (!v) {
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Indisponível';
        return;
      }
      current = v;
      renderPrice(v);
      addButton.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
      if (v.featured_image && mainImg && !primeiraPassada) {
        trocarFoto(
          v.featured_image.src.replace(/(\.[^.?]*)(\?|$)/, '_1200x$1$2'),
          v.featured_image.alt || v.title || ''
        );
        marcarThumb(v.featured_image.id);
      }
      primeiraPassada = false;
    }

    /* Mantém a fila de miniaturas em sincronia com a foto grande. */
    function marcarThumb(idImagem) {
      var trilho = section.querySelector('[data-gallery-thumbs]');
      if (!trilho || !mainImg) return;
      var atual = mainImg.getAttribute('src').split('?')[0];
      trilho.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        var alvo = (b.getAttribute('data-src') || '').split('?')[0];
        var ativa = alvo === atual;
        b.classList.toggle('is-active', ativa);
        if (ativa) { b.setAttribute('aria-current', 'true'); b.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
        else { b.removeAttribute('aria-current'); }
      });
    }

    /* Clique na miniatura troca a foto grande. Ficava num snippet de galeria
       que a PDP não usa, então no ar as miniaturas não faziam nada. */
    var trilhoThumbs = section.querySelector('[data-gallery-thumbs]');
    if (trilhoThumbs && mainImg) {
      trilhoThumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gallery-thumb]');
        if (!btn) return;
        trocarFoto(btn.getAttribute('data-src'), btn.getAttribute('data-alt'));
        trilhoThumbs.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          var ativa = b === btn;
          b.classList.toggle('is-active', ativa);
          if (ativa) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
        });
      });
    }

    selectors.forEach(function (s) { s.addEventListener('change', update); });

    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      addButton.disabled = true;
      addVariant(current.id, parseInt(qtyInput.value, 10) || 1)
        .catch(function (err) { console.error(err); })
        .finally(function () { addButton.disabled = false; });
    });

    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    getCart().then(setCount);
    initProduct();
  });
})();
